module.exports = __webpack_public_path__ + "assets/img/04.f34559de.png";